import Rails from 'rails-ujs';


class Ajax {
  constructor() {
    this.init();
  }

  init() {}


  rails(url, method, data = '', dataType = 'script'){
    Rails.ajax({
      type: method,
      url: url,
      data: data,
      contentType: false,
      dataType: dataType,
      // success: (data, textStatus, errorThrown) => {},
      error: function(jqXHR, textStatus){ console.log('No products found for this params'); }
    })
  }


  get(url, successCallback) {
    return new Promise((resolve, reject) => {
      const xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');

      xhr.open('GET', url);
  		xhr.onreadystatechange = () => {
  			if (xhr.readyState > 3 && xhr.status === 200) {
          if (!!successCallback) successCallback(xhr.responseText);
  			} else if (xhr.readyState < 3 && xhr.status !== 200) {
          console.error('Get request error: ' + xhr.status);
        }
  		};
  		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  		xhr.send();

  		return xhr;
    });
  }


  post(url, data, contentType = 'application/x-www-form-urlencoded', successCallback) {
    const params = typeof data == 'string' ? data : Object.keys(data).map((k) => {
      return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
    }).join('&');
		const xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');

		xhr.open('POST', url);
		xhr.onreadystatechange = () => {
			if (xhr.readyState > 3 && xhr.status === 200) {
        console.info('Post success!');
        if (!!successCallback) successCallback(xhr.responseText);
			} else if (xhr.readyState < 3 && xhr.status !== 200) {
        console.error('Post request error: ' + xhr.status);
      }
		};
    // The header X-Requested-With allows server side frameworks( such Rails,Django etc.) to identify Ajax requests
		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		xhr.setRequestHeader('Content-Type', contentType);
		xhr.send(params);

		return xhr;
  }


  getCORS(url, successCallback) {
    let xhr = new XMLHttpRequest();
    if (!('withCredentials' in xhr)) xhr = new XDomainRequest(); // fix IE8/9

    xhr.open('GET', url);
    xhr.onload = successCallback;
    xhr.send();
    // $INFO: the actual response is found in currentTarget.response or target.responseText.
    // Sample of ta successCallback getting the response
    // getCORS('http://foo.bar/?p1=1&p2=Hello+World', function(request){
    //   var response = request.currentTarget.response || request.target.responseText;
    //   console.log(response);
    // });
    return xhr;
  }
}


export default Ajax;
